interface StoreIdProps {
  storeId: number;
}

export const StoreId = ({ storeId }: StoreIdProps) => (
  <div id="jane-store-id" data-store-id={storeId} />
);
